import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { parseDrugCode } from "../../../../helpers/commonHelper";
import { QuarantinedProductsToReturnStockInterface } from "../../../../redux/interfaces/receipt.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const returningProductsToProviderTableHeader = (
  providers: { id: number; label: string }[],
  invoices: {
    idFactura: number;
    codFactura: string;
    idFurnizor: number;
  }[],
): TableHeaderCategoryConfig[] => {
  return [
    {
      label: "",
      value: "selected",
      minW: 125,
    },
    {
      label: "Denumire produs",
      value: "numeProdusErp",
      withSearch: true,
      minW: 125,
    },
    {
      label: "Cod grupa",
      value: "codGrupa",
      minW: 125,
    },
    {
      label: "Cod produs",
      value: "codProdus",
      withSearch: true,
      minW: 125,
    },
    {
      label: "Lot",
      value: "lot",
      minW: 125,
    },
    {
      label: "Data expirare",
      value: "dataExpirare",
      minW: 125,
    },
    {
      label: "Furnizor",
      value: "provider",
      withFilter: [
        { label: "Toate", value: "0" },
        ...providers.map((provider) => ({
          label: provider.label,
          value: provider.id,
        })),
      ],
      minW: 125,
    },
    {
      label: "Facturi",
      value: "invoice",
      withFilter: [
        { label: "Toate", value: "0" },
        ...invoices
          .filter(
            (invoice): invoice is NonNullable<typeof invoice> => !!invoice,
          )
          .map((invoice) => ({
            label: invoice.codFactura,
            value: invoice.idFactura,
          })),
      ],
      minW: 125,
    },
    {
      label: "Cantitate",
      value: "cantitate",
      minW: 50,
    },
    {
      label: "Locatie",
      value: "reason",
      minW: 100,
    },
  ];
};

export const getReturningProductsToProviderTableData: any = (
  inventoryReturningProductsToProviderList: QuarantinedProductsToReturnStockInterface[],
) =>
  inventoryReturningProductsToProviderList?.map((item) => {
    const invoices = item.furnizori.flatMap((furnizor) => furnizor.facturi);
    return {
      id: item.idActivCel,
      crudData: item,
      data: [
        {
          checkbox: true,
        },
        {
          title: item.numeProdusErp,
        },
        {
          title: item.codGrupa ? parseDrugCode(item.codGrupa) : "-",
        },
        {
          title: item.codProdus,
        },
        {
          title: item.lot,
        },
        {
          badges: [
            {
              badgeText: `${dateToString(item.dataExpirare ?? "-")}`,
              badgeColor: "light-danger",
            },
          ],
        },
        {
          badges: item.furnizori.map((furnizor) => {
            return {
              badgeText: furnizor.label,
              badgeColor: "light-info",
            };
          }),
        },
        {
          title:
            invoices
              .map((invoice) => {
                return invoice?.codFactura;
              })
              .join(", ") || "-",
        },
        {
          title: item.cantitate,
        },
        {
          title: item.locatie,
        },
      ],
    };
  });
